<ng-template #loaderBlock>
  <app-loader></app-loader>  
</ng-template>
<div class="transition-wrapper">
    <!-- <ng-container *ngFor="let assetData of assetLibraries">
        <div class="transitionCard">
            <div class="ALCardBanner" [ngStyle]="{'background': 'url(' + assetData.headerImage + ') no-repeat center center'}">
                <p class="ALYellowLabel">{{assetData.yellowTag}}</p>
                <p class="ALBlueLabel">{{assetData.blueTag}}</p>
            </div>
            <div class="ALCardContent">
                <div class="ALHeader">
                    {{assetData.assetTitle}}
                </div>
                <div class="color-div"></div>
                <div class="ALContent" [title]="assetData.description">
                   <span>
                        {{assetData.description}}
                   </span>
                </div>
                <div class="ALContent2">
                    <div>
                        <span class="ALlabel">Service Line</span>
                        <span class="ALvalue"> {{assetData.serviceLine}} </span>
                    </div>
                    <div>
                        <span class="ALlabel">Competency</span>
                        <span class="ALvalue"> {{assetData.competency}}</span>
                    </div>
                </div>
            </div>
        </div>
    </ng-container> -->
    
  <ng-container *ngFor="let trans of visibleTransitions">
    <div class="transitionCard" (click)="goto('Transition Page', trans)">
        <div class="ALCardBanner" [ngStyle]="{'background': 'url(' + trans.headerImageUrl + ') 0% 0% / cover rgba(0, 0, 0, 0.3)'}">
            <p class="ALRAGLabel"
            [ngClass]="{
              green: trans.rag === 'On Track',
              red: trans.rag === 'At Risk',
              yellow: trans.rag === 'Delayed'
            }">{{trans.rag}}</p>
        </div>
        <div class="ALCardContent">
            <div class="ALHeader">
              {{trans.projectName}}
            </div>
            <div class="ALContent">
              <img [src]="trans.projectTypeIconUrl ? trans.projectTypeIconUrl : 'assets/images/quantum-leap-logo.svg'" alt="Icon">
               <!-- <img [src]="trans.projectTypeIconUrl"/> -->
               <div class="right-content">
                 <label class="transition-label "><img src="/assets/images/people_outline.svg"/>CLIENT NAME</label>
                 <p class="label-data">{{trans.clientName}}</p>
                 <label class="transition-label mt-1"><img src="/assets/images/Calendar 1.svg"/>PROJECT DURATION</label>
                 <p class="label-data">{{trans.projectStart | date : "dd/MM/yyyy"}} <img src="/assets/images/Vector.svg"/>  {{trans.projectEnd | date : "dd/MM/yyyy"}}</p>
               </div>
            </div>
        </div>
    </div>
</ng-container>

  <ng-container *ngIf="!loading; else loaderBlock"> </ng-container>
</div>
